import { sprintf } from 'sprintf-js';

import { Body } from 'components/Text/Body';
import { H1 } from 'components/Text/H1';
import { MainChartData } from 'modules/salaries/types/MainChartData';
import { colors } from 'theme/theme';

type CareerPathHeaderProps = {
  data: MainChartData;
};

export function CareerPathHeader({ data }: CareerPathHeaderProps) {
  return (
    <>
      <H1 color={colors.black} styleAs="h2" textAlign="center" mb="12px">
        {data.submittedData?.city
          ? sprintf(getText('Explore Your Career Path in %(workLocation)s'), {
              workLocation: `${data.submittedData.city}, ${data.submittedData.stateCode}`,
            })
          : getText('Explore Your Career Path')}
      </H1>
      <Body lineHeight={1.5} color={colors.black} textAlign="center">
        <em>
          {getText(
            'See what you could be earning in related roles as you level up your skills and experience.',
          )}{' '}
        </em>
      </Body>
    </>
  );
}
